/*
 * Copyright (c) 2021 biocrates life sciences ag, All rights reserved.
 */

import update from "immutability-helper"
import {getType} from "typesafe-actions"

import {
    getGroupSettingsSuccessAction,
    getSettingSuccessAction,
    SettingsActions,
    updateSettingAction,
} from "../actions/settings.actions"

const getSettingsReducer = <S>(initialState: S) => (
    state: any = initialState,
    action: SettingsActions
): S => {
    switch (action.type) {
        case getType(updateSettingAction):
            return update(state, {
                [action.payload.group]: {
                    [action.payload.key]: {
                        $set: action.payload.value,
                    },
                },
            })
        case getType(getSettingSuccessAction):
            return update(state, {
                [action.payload.group]: {
                    initialized: {$set: true},
                    [action.payload.key]: {
                        $set: action.payload.value,
                    },
                },
            })
        case getType(getGroupSettingsSuccessAction):
            return update(state, {
                [action.payload.group]: {
                    $set: {
                        ...state[action.payload.group],
                        ...action.payload.value,
                        initialized: true,
                    },
                },
            })
        default:
            return state
    }
}

export default getSettingsReducer
